<template>
    <div class="container-fluid">
        <ListEquipments colClass="col-12" headerTitle="true" titles="true" title="รายละเอียดอุปกรณ์" v-model:details="formMA"/>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent, watch } from 'vue'
import Swal from 'sweetalert2'
import { downloadPDF } from "@/services/generate-pdf";

const ListEquipments = defineAsyncComponent(() => import("@/components/theme/ma/ListEquipments.vue"))
</script>